import { useAddress, useNetwork } from "../contexts/Context";
// import Web3 from 'web3'
import { useEffect, useState } from "react";
import { checkCorrectNetwork, connectMetamask, requiredSwitchNetwork } from '../utils/connectMetamask'
import connectWalletLogo from '../assets/new-ui/connect-wallet-logo.png'
import ModalOptionConnect from './ModalOptionConnect'
import ModalSwitchNetwork from './ModalSwitchNetwork'

export default function ConnectWallet() {
  // const web3 = new Web3(Web3.givenProvider)
  const [ethAddress, setEthAddress] = useAddress()
  const [networkId,setNetworkId] = useNetwork()
  const [optionConnectBox,setOptionConnectBox] = useState(false)
  const [switchNetworkBox,setSwitchNetworkBox] = useState(false)

  useEffect(() => {
    if (ethAddress && networkId && checkCorrectNetwork(networkId)) {
      setOptionConnectBox(false)
      setSwitchNetworkBox(false)
    }
    else if (ethAddress && networkId && !checkCorrectNetwork(networkId)) {
      setOptionConnectBox(false)
      setSwitchNetworkBox(true)
    }
  },[ethAddress,networkId])

  async function checkInstallMetamask(){
    if (!window.ethereum) {//not install metamask
      window.open('https://metamask.io/download', '_blank')
    }
    else if (window.ethereum && !ethAddress) { //install metamask but not connect
      setOptionConnectBox(true)
    }
  }

  function connecWallet() {
    connectMetamask().then(result => {
      if (result) {
        setEthAddress(result.address)
        setNetworkId(result.network)
      }
    })
  }

  function switchNetwork() {
    requiredSwitchNetwork().then(result => {
      setNetworkId(result)
    })
  }

  return (
    <>
      <ModalOptionConnect 
        toggleModal={optionConnectBox}
        setToggleModal={setOptionConnectBox}
        connectMetamask={connecWallet}
      />

      <ModalSwitchNetwork 
        toggleModal={switchNetworkBox}
        switchNetwork={switchNetwork}
      />
      <div className={!ethAddress ? 'connectWalletMobile' : 'connectWalletMobileHidden'} onClick={() => checkInstallMetamask()}>
        <img src={connectWalletLogo} alt='wallet logo' />
        <div className='connectWalletText'>
          CONNECT WALLET
        </div>
      </div>
    </>
    
  )
}